import { Component } from '@angular/core';

@Component({
    selector: '[cmpsEventCentreCardTimestamp]',
    template: ` <ng-content></ng-content>`,
    host: {
        class: 'cmps-event-centre-card-timestamp',
    },
})
export class CardTimestampComponent {}
